import React, { Component } from "react";
import { Row, Col } from "reactstrap";

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <footer className="footer">
          <div className="container-fluid">
            <Row>
              <Col sm={6}>© {new Date().getFullYear()} Tax Consult HR Tax & International Mobility</Col>
              <Col sm={6}>
                {/* <div className="text-sm-end d-none d-sm-block">{process.env.REACT_APP_NAME}</div> */}
                <div className="text-sm-end d-none d-sm-block">Powered by <a href="https://bigwater.consulting/"  target="_blank">BIG WATER CONSULTING</a></div>
              </Col>
            </Row>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default Footer;
